namespace appn.views.tasks.calendar {

    class InitArgs {
        users: Array<AppnSelectListItem> = [];
        userGroups: Array<SelectListItem> = [];
        timeZones: Array<SelectListItem> = [];
        startOfCalendarWeek: number = 1;
        tasksCalendar: string = emptyString;
        tasksCalendarData: string = emptyString;
        tasksCalendarEdit: string = emptyString;
        tasksEdit: string = emptyString;
        taskRecurringEdit: string = emptyString;
        taskTemplatesWizard1: string = emptyString;
    }

    class CalendarEdits {
        maxSaveChanges: number = 5;
        isInEditMode: boolean = false;
        hasShownEditModeNotify: boolean = false;
        items: Array<any> = [];

        addItem(newEditItem: any): void {
            if (newEditItem)
                this.items.push(newEditItem);
            this.updateSaveButton();
        }

        hasUnsavedChanges(): boolean {
            return this.items.length > 0 ? true : false;
        }

        clearItems(): void {
            this.items = [];
            this.updateSaveButton();
        }

        distinctTasks(draggingTaskId?: any): number {
            const flags = new Array<any>();
            const output = new Array<any>();

            for (let i = 0; i < this.items.length; i++) {
                if (flags[this.items[i].TaskId]) continue;
                flags[this.items[i].TaskId] = true;
                output.push(this.items[i].TaskId);
            }
            // account for dragging item not yet being in the calendarEdits.items array
            return draggingTaskId === undefined || flags[draggingTaskId] ? output.length : output.length + 1;
        }

        updateSaveButton(): void {
            if (this.items.length === 0) {
                $('#btn-Save').hide();
                $('#btn-Cancel').hide();
                $('#btn-AddNew').show();
                $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select,#ColorByStatus,#ColorByUser,#ColorByTemplateType').prop('disabled', false);
                $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select').removeClass('fc-state-disabled');
                $('.fc-day-header').show();
                this.isInEditMode = false;
                this.hasShownEditModeNotify = false;
                return;
            }

            this.isInEditMode = true;
            $('#btn-Save').html(T('Save Changes') + ' <i class=" fa fa-save "></i>');
            $('#btn-Save').show();
            $('#btn-Cancel').show();
            $('#btn-AddNew').hide();
            $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select,#ColorByStatus,#ColorByUser,#ColorByTemplateType').prop('disabled', true);
            $('.fc-daygrid-day-number,.fc-toolbar button,.fc-toolbar select').addClass('fc-state-disabled');
            $('.fc-day-header').hide();

            if (!this.hasShownEditModeNotify) {
                appn.toast.notify(toast.Type.info, T('<b>Calendar is now in Edit Mode</b><br>Current view and filters are locked until you save or cancel your changes.'));
                this.hasShownEditModeNotify = true;
            }
        }

    }

    let _initArgs: InitArgs;
    let _defaultView: any = {};
    export let _isCanEditOrMoveMessageShowing: boolean = false;
    const _usersColorClasses: any[] = [];
    const _templateTypesColorClasses: any[] = [];
    let _calendarEdits: CalendarEdits;

    // fullcalendar
    let _fcObject: any = {};
    let _fcView: any = {};
    let _fc: any = {};

    export function init(args: InitArgs): void {
        _initArgs = args;
        _calendarEdits = new CalendarEdits();
        _defaultView = appn.sessionStorage.getItem('defaultCalendarView');
        if (!_defaultView)
            _defaultView = { viewName: 'dayGridMonth', viewDate: null };

        addEvents();
        appn.taskTemplateFilter.init();
        setColorBy();

        // Init Calendar
        const calendarEl = document.getElementById('taskCalendar');
        const options = new CalendarOptions('taskCalendar');
        const calendar = new (window as any).FullCalendar.Calendar(calendarEl, options);
        calendar.render();
    }

    function addEvents() {

        $('#clearParentTask').on('click', function(e: Event) {
            appn.location.navTo(_initArgs.tasksCalendar);
        });

        if ($('#ParentTaskId').val() !== undefined)
            $(document).on('click', '.btn-resetFilters', function(e: Event) {
                appn.location.navTo(_initArgs.tasksCalendar);
            });

        $('.users-legend ul li').each(function(i: number, item: HTMLElement) {
            const colorClasses = $(item)?.attr('class')?.split(' ') ?? appn.emptyString;
            for (let ix = 0; ix < colorClasses.length; ix++)
                if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                    _usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClasses[ix] });
                    break;
                }
        });

        $('.template-type-legend ul li').each(function(i: number, item: HTMLElement) {
            const colorClasses = $(item)?.attr('class')?.split(' ') ?? appn.emptyString;
            for (let ix = 0; ix < colorClasses.length; ix++)
                if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                    _templateTypesColorClasses.push({ name: $(item).prop('id'), colorClass: colorClasses[ix] });
                    break;
                }
        });

        $('#ColorByStatus,#ColorByUser,#ColorByTemplateType').off().on('change', function() {
            const id = $(this).prop('id');

            if (id === 'ColorByStatus')
                setColorBy('statuses');

            if (id === 'ColorByUser')
                setColorBy('users');

            if (id === 'ColorByTemplateType')
                setColorBy('templateTypes');

            getCalendarJsonDataFromServer();
        });

        $('#btn-Cancel').on('click', function() {
            appn.dialog.confirm({
                modalColor: 'modal-danger',
                title: T('Discard Calendar Changes?'),
                message: T('Your changes to {0} Task(s) will be lost...are you sure about this?<br><br>Hit <b>OK</b> to proceed.', _calendarEdits.distinctTasks()),
                isDeleteAction: true,
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        _calendarEdits.clearItems();
                        appn.location.reloadCurrentPage();
                    }
                }
            });

        });

        $('#btn-Save').off().on('click', function() {
            submitCalendarEditsToServer();
        });
    }

    function toggleManageBtn(isActive: boolean) {
        // Original function (from .cshtml js) outside doc.ready; 
        // Not used anywhere else in the code - cshtml or js
        if (isActive)
            $('#manageBtn').attr('disabled', 'false');
        else
            $('#manageBtn').attr('disabled', appn.emptyString);
    }

    function showLoadingModalIfLargeDataQuery() {
        appn.dialog.showLoading();
    }

    export function getCalendarJsonDataFromServer() {
        const view = _fcView;

        const nameValues: Array<INameValuePair> = [];

        nameValues.push({ name: 'v', value: new Date().getTime().toString() });

        // Status Filter
        const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
        if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
            statusToFilterBy.value = '';
        nameValues.push({ name: 'statusFilter', value: statusToFilterBy.value });

        // User Filter
        const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
        if (!userToFilterBy.value || userToFilterBy.value === 'All')
            userToFilterBy.value = '';
        nameValues.push({ name: 'userFilterId', value: userToFilterBy.value });

        // User Groups Filter
        if (_initArgs.userGroups.length !== 0) {
            const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupsFilter', $('#userGroupsFilter').val());
            if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                userGroupToFilterBy.value = appn.emptyString;
            nameValues.push({ name: 'userGroupFilterId', value: userGroupToFilterBy.value });
        }

        // Timezone Filter
        const timeZoneToFilterBy = appn.dataTable.getStateOrDefault('timeZoneFilter', $('#timeZoneFilter').val());
        if (!timeZoneToFilterBy.value || timeZoneToFilterBy.value === 'All')
            timeZoneToFilterBy.value = '';
        nameValues.push({ name: 'timeZoneId', value: timeZoneToFilterBy.value });

        // View Filter
        nameValues.push({ name: 'dateFilterFrom', value: view.dateProfile.currentRange.start.toISOString() });
        nameValues.push({ name: 'dateFilterTo', value: view.dateProfile.currentRange.end.toISOString() });

        // Type filter
        nameValues.push({ name: 'templateId', value: appn.taskTemplateFilter.getStateOrDefault().value });
        nameValues.push({ name: 'parentTaskId', value: $('#ParentTaskId').val() || '' });

        // BUILD AJAX URL
        const params = appn.location.buildQueryString(nameValues);
        const url = _initArgs.tasksCalendarData + params;

        // --- AJAX POST ---
        showLoadingModalIfLargeDataQuery();
        appn.ajax.post({
            url: url,
            dataType: 'json',
            done: function(dataParsed: any, p1: any, p2: any, p3: any) {
                ajaxPostDone(dataParsed, p1, p2, p3);
            },
            fail: function(p1: any, p2: any, p3: any) {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Calendar Data Load Failed'),
                    message: T('Failed to load calendar data. Please sign out and sign in again. Contact support if this problem persists.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
            },
            always: function() {
                appn.dialog.hideLoading();
            }
        });

    }

    function ajaxPostDone(dataParsed: any, p1: any, p2: any, p3: any): void {
        // Clear current events
        _fc.removeAllEvents();

        const defaultStatusColorsParsed = JSON.parse(dataParsed.DefaultStatusColors);

        // Render Events on calendar
        // Apply Coloring of events based on status
        const calendarEventsToRender: Array<EventObject> = [];

        if (dataParsed.TaskCalendarDataItems && dataParsed.TaskCalendarDataItems.length > 0)
            // loop through the server data and populate calendar events obj
            for (let i = 0; i < dataParsed.TaskCalendarDataItems.length; i++) {
                // Get the color of the status
                let colorToAdd = '';
                let colorClassToAdd = '';

                const colorBy = $('#ColorByStatus').prop('checked') === true ? 'statuses' : 'users';

                if ($('#ColorByStatus').prop('checked')) {
                    dataParsed.TaskCalendarDataItems[i].UserColorCode = appn.emptyString;

                    if (!dataParsed.TaskCalendarDataItems[i].IsTaskRecurring) {
                        // Grab the default status
                        const status = dataParsed.TaskCalendarDataItems[i].Status.trim().toLowerCase();
                        let statusToCompare = status;
                        if (dataParsed.TaskCalendarDataItems[i].CustomStatus)
                            // We have a custom status -> use this rather
                            statusToCompare = dataParsed.TaskCalendarDataItems[i].CustomStatus.trim().toLowerCase();

                        // Loop through the custom status object and find the right color
                        if (statusToCompare)
                            for (let j = 0; j < dataParsed.MergedStatuses.length; j++) {
                                if (!dataParsed.MergedStatuses[j].Color || !dataParsed.MergedStatuses[j].Color.trim())
                                    break;

                                // Valid color exists
                                if (dataParsed.MergedStatuses[j].Value.trim().toLowerCase() === statusToCompare) {
                                    colorToAdd = dataParsed.MergedStatuses[j].Color;
                                    break;
                                }
                            }

                        if (!colorToAdd)
                            // Set default colors
                            colorToAdd = defaultStatusColorsParsed[dataParsed.TaskCalendarDataItems[i].Status];
                    }
                }

                if ($('#ColorByUser').prop('checked'))
                    // Get user colors
                    $(_usersColorClasses).each(function(ii: number, item: any) {
                        if (item.userId === dataParsed.TaskCalendarDataItems[i].AppUserId) {
                            if (item.colorClass)
                                colorClassToAdd = item.colorClass;
                            return false;
                        }
                    });

                if ($('#ColorByTemplateType').prop('checked')) {
                    dataParsed.TaskCalendarDataItems[i].UserColorCode = appn.emptyString;
                    // Get user colors
                    $(_templateTypesColorClasses).each(function(ii: number, item: any) {
                        if (item.name === dataParsed.TaskCalendarDataItems[i].TemplateName) {
                            colorClassToAdd = item.colorClass;
                            return false;
                        }
                    });
                }

                // Populate the event
                const eventTitle = `${dataParsed.TaskCalendarDataItems[i].AssignedTo} - ${dataParsed.TaskCalendarDataItems[i].TaskName}`;

                // Push new event to calendar events obj ready to render
                calendarEventsToRender.push({
                    // color: colorToAdd,
                    id: dataParsed.TaskCalendarDataItems[i].Id,
                    groupId: dataParsed.TaskCalendarDataItems[i].TaskId,
                    allDay: dataParsed.TaskCalendarDataItems[i].IsAllDay,
                    start: dataParsed.TaskCalendarDataItems[i].Start,
                    end: dataParsed.TaskCalendarDataItems[i].End,
                    startStr: (window as any).moment(dataParsed.TaskCalendarDataItems[i].Start).toISOString(),
                    endStr: (window as any).moment(dataParsed.TaskCalendarDataItems[i].End).toISOString(),
                    title: eventTitle,
                    url: '#',
                    classNames: [],
                    editable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                    startEditable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                    durationEditable: dataParsed.TaskCalendarDataItems[i].CanEditOrMove,
                    resourceEditable: false,
                    display: 'block', // The rendering type of this event.Can be 'auto', 'block', 'list-item', 'background', 'inverse-background', or 'none'
                    overlap: true,
                    constraint: {},
                    backgroundColor: colorToAdd,
                    borderColor: colorToAdd,
                    textColor: '',
                    extendedProps: {
                        parentId: dataParsed.TaskCalendarDataItems[i].ParentId,
                        taskStatus: dataParsed.TaskCalendarDataItems[i].Status,
                        taskType: dataParsed.TaskCalendarDataItems[i].TemplateName,
                        isRecurring: dataParsed.TaskCalendarDataItems[i].IsTaskRecurring,
                        startBy: dataParsed.TaskCalendarDataItems[i].StartBy,
                        completeBy: dataParsed.TaskCalendarDataItems[i].CompleteBy,
                        templateName: dataParsed.TaskCalendarDataItems[i].TemplateName,
                        additionalInfo: dataParsed.TaskCalendarDataItems[i].AdditionalInfo,
                        recurringTaskName: dataParsed.TaskCalendarDataItems[i].RecurringTaskName,
                        taskRecurringId: dataParsed.TaskCalendarDataItems[i].TaskRecurringId,
                        taskId: dataParsed.TaskCalendarDataItems[i].TaskId,
                        taskName: dataParsed.TaskCalendarDataItems[i].TaskName,
                        completeAtText: dataParsed.TaskCalendarDataItems[i].CompleteAtText,
                        completeAtLat: dataParsed.TaskCalendarDataItems[i].CompleteAtLat,
                        completeAtLon: dataParsed.TaskCalendarDataItems[i].CompleteAtLon,
                        canEditOrMoveMessage: dataParsed.TaskCalendarDataItems[i].CanEditOrMoveMessage,
                        assignedToId: dataParsed.TaskCalendarDataItems[i].AssignedToId,
                        userColorCode: dataParsed.TaskCalendarDataItems[i].UserColorCode,
                        colorClass: colorClassToAdd,
                        flashMe: false,
                        hasBeenMoved: false

                    },
                    source: null
                });
            }

        // Populate new events
        // batchRendering is important to avoid browser freeze with lots of events
        _fc.batchRendering(function() {
            calendarEventsToRender.forEach((event: any) => {
                _fc.addEvent(event, true);
            });
        });

        // $("#calendar").fullCalendar('addEventSource', eventData1, true);


        $('#taskCalendar .appn-calendar-filters').remove();
        $('#taskCalendar .fc-toolbar.fc-header-toolbar').after(`<div class="appn-calendar-filters"></div>`);

        // RENDER Timezone Select Box ---------------
        // Update UI with new timezone box

        $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.timeZones, 'timeZoneFilter', 'saveMeState')}`);

        // RENDER User Groups Select Box ---------------

        if (_initArgs.userGroups.length !== 0)
            // Update UI with new user groups box
            $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupsFilter', 'saveMeState')}`);

        // RENDER Users Select Box ---------------
        // Update UI with new user box
        $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildSelect(_initArgs.users, 'userFilter', 'saveMeState select2-noinit')}`);

        // RENDER STATUS Select Box ---------------
        // Update UI with new status box
        $('#taskCalendar .appn-calendar-filters').append(`${appn.elementBuilder.buildTaskStatusSelect(dataParsed.MergedStatuses, 'statusFilter', 'saveMeState')}`);

        // Status Legend - Update colors and statuses
        $('.statuses-legend ul li').remove();
        let statusesToAddLegend = '';
        for (let i = 0; i < dataParsed.MergedStatuses.length; i++)
            statusesToAddLegend += `<li style="background-color: ${dataParsed.MergedStatuses[i].Color};" role="presentation" class="folder " id="${dataParsed.MergedStatuses[i].Value}">` +
                `<span class="text-whitesmoke" id="">${dataParsed.MergedStatuses[i].Display}</span></li>`;
        $('.statuses-legend ul').append(statusesToAddLegend);

        // Append filter button
        appn.sideFilterAndContent.appendShowButton($('#taskCalendar .appn-calendar-filters'));

        appn.actionButtons.renderNavbarActionButtons([
            {
                buttonId: 'addnew',
                buttonType: 'AddNew'
            }
        ], appn.requestUser.isUserOrHigher);

        $('#addnew').off().on('click', function(e: Event) {
            e.preventDefault();
            appn.tasks.showAddNewDialog(false, false, undefined, undefined, false, T('Calendar'));
        });

        appn.saveMeState.init(function() {
            getCalendarJsonDataFromServer();
        },
            function() {
                setColorBy('users');

                appn.sessionStorage.removeItem('defaultCalendarView');
                const view = _fcView.getCurrentData();

                if (view.currentViewType === ViewSpecs.dayGridMonth)
                    getCalendarJsonDataFromServer();
                else
                    _fc.changeView(ViewSpecs.dayGridMonth, _defaultView.viewDate);

            }, '#taskCalendar .appn-calendar-filters');

        select.init();
        select.init({ selector: '#userFilter', minimumResultsForSearch: '25' }); // Start displaying 'search' at 25 items

        // Finished processing -> remove modal
        appn.dialog.hideLoading();
    }

    function setColorBy(colorBy?: string) {
        if (!colorBy) {
            colorBy = appn.localStorage.getItem('defaultColorBy');

            if (!colorBy)
                colorBy = 'users';
        }

        appn.localStorage.setItem('defaultColorBy', colorBy);

        if (colorBy === 'statuses') {
            $('#ColorByStatus').prop('checked', true);
            $('#ColorByUser').prop('checked', false);
            $('#ColorByTemplateType').prop('checked', false);
        }

        if (colorBy === 'users') {
            $('#ColorByUser').prop('checked', true);
            $('#ColorByStatus').prop('checked', false);
            $('#ColorByTemplateType').prop('checked', false);
        }

        if (colorBy === 'templateTypes') {
            $('#ColorByTemplateType').prop('checked', true);
            $('#ColorByStatus').prop('checked', false);
            $('#ColorByUser').prop('checked', false);
        }
    }


    function submitCalendarEditsToServer(): void {
        appn.dialog.showLoading();

        // Get Timezone for these changes
        const timeZoneToFilterBy = appn.dataTable.getStateOrDefault('timeZoneFilter', $('#timeZoneFilter').val());
        if (!timeZoneToFilterBy.value || timeZoneToFilterBy.value === 'All')
            timeZoneToFilterBy.value = '';

        appn.ajax.post({
            url: _initArgs.tasksCalendarEdit,
            dataType: 'json',
            data: { TaskCalendarEditItems: _calendarEdits.items, TimeZoneId: timeZoneToFilterBy.value },
            always: function(dataParsed: any, p1: any, p2: any, p3: any) {
                _calendarEdits.clearItems();
                getCalendarJsonDataFromServer();
                appn.dialog.hideLoading();
                appn.toast.notify(toast.Type.info, T('Your changes were saved successfully.'));
            },
            fail: function(p1: any, p2: any, p3: any) {
                appn.dialog.hideLoading();
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Calendar Edit Failed'),
                    message: T('Failed to save changes to calendar data.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        appn.location.reloadCurrentPage();
                    }
                });
            }
        });
    }

    function addItemEvents(event: EventObject, modal: JQuery<HTMLElement>) {
        $(modal).on('click', 'button[value="Details"]', function(e) {
            e.preventDefault();
            const isrecur = event.extendedProps.isRecurring;

            if (isrecur)
                appn.location.navTo(_initArgs.tasksEdit, [
                    { name: 'taskRecurringId', value: event.extendedProps.taskRecurringId },
                    { name: 'returnAction', value: 'Calendar' }
                ]);
            else
                appn.location.navTo(_initArgs.tasksEdit, [
                    { name: 'id', value: event.id },
                    { name: 'returnAction', value: 'Calendar' }
                ]);
        });

        $(modal).on('click', 'button[value="Schedule"]', function(e) {
            e.preventDefault();
            appn.location.navTo(_initArgs.taskRecurringEdit, [
                { name: 'id', value: event.extendedProps.taskRecurringId },
                { name: 'returnAction', value: 'Calendar' }
            ]);
        });

        $(modal).on('click', 'button[value="Children"]', function(e) {
            e.preventDefault();
            appn.location.navTo(_initArgs.tasksCalendar, [
                {
                    name: 'parentTaskId',
                    value: event.extendedProps.parentId
                }
            ]);
        });

    }

    function newEditItem(calendarEditAction: string, fcEvent: EventObject) {
        return {
            CalendarEditAction: calendarEditAction,
            TaskId: fcEvent.extendedProps.taskId,
            IsAllDay: fcEvent.allDay,
            TimeStamp: new Date().getTime(),
            Start: (window as any).moment(fcEvent.start).format('YYYY-MM-DD HH:mm:ss'),
            End: fcEvent.end ? (window as any).moment(fcEvent.end).format('YYYY-MM-DD HH:mm:ss') : null
        };
    }

    function showInEditModeNotify(): boolean {
        if (_calendarEdits.isInEditMode) {
            appn.toast.notify(toast.Type.error, T('Your action was blocked because the calendar is currently in Edit mode.<br><br>Hit Save to keep your changes or discard them by hitting Cancel.'));
            return true;
        }
        return false;
    }

    class CalendarOptions {
        // ===== Header Toolbar variables and callbacks start =====
        headerToolbar: Object = {
            start: 'prev,next today', // will normally be on the left. if RTL, will be on the right
            center: 'title',
            end: `${ViewSpecs.dayGridMonth},${ViewSpecs.timeGridWeek},${ViewSpecs.timeGridDay},${ViewSpecs.listWeek}` // will normally be on the right. if RTL, will be on the left
        };

        // ===== Header Toolbar variables and callbacks end =====

        // ===== Calendar View variables and callbacks start =====
        aspectRatio: number = 2; // this gets updated as the window resizes to keep up with the viewport asprect ratio
        businessHours: boolean = false; // display business hours
        firstDay: number = 0;
        handleWindowResize: boolean = true;
        height: string = '100%';
        initialDate: string = _defaultView.viewDate;
        initialView: string = _defaultView.viewName;
        locale: string = 'en-GB';
        navLinks: boolean = true; // can click day/week names to navigate views
        showNonCurrentDates: boolean = true; // shows/hides greyed out dates from overlapping months in month view
        themeSystem: string = 'bootstrap';
        timeZone: string = 'local';
        windowResizeDelay: number = 25;

        datesSet: Function = function(dateInfo: any) {
            // This is where we update the current view when any view display changes are made
            _fcObject = dateInfo;
            _fcView = _fcObject.view.getCurrentData();
            _fc = _fcObject.view.calendar;

            appn.views.tasks.calendar.getCalendarJsonDataFromServer();
            
            appn.sessionStorage.setItem('defaultCalendarView', {
                viewName: dateInfo.view.type,
                viewDate: (window as any).moment(_fcView.currentDate).format('YYYY-MM-DD')
            });
        };

        navLinkDayClick: Function = function(date: Date, jsEvent: any) {
            if (_calendarEdits.isInEditMode)
                return false;

            _fc.changeView(ViewSpecs.timeGridDay, date);
        };

        viewDidMount: Function = function(view: any) {
            // This is called as soon as the calendar is mounted to the DOM
            _fcObject = view;
            _fcView = _fcObject.view.getCurrentData();
            _fc = _fcObject.view.calendar;
        };

        windowResize: Function = function(arg: any) {
            // Set a new aspect ratio for the calendar when resizing the viewport
            arg.view.calendar.setOption('aspectRatio', getParentAspectRatio($(_fc.el).attr('id') as string));
            arg.view.calendar.render();
        };

        // ===== Calendar View variables and callbacks end =====


        // ===== Calendar Events variables and callbacks start =====
        dayMaxEventRows: boolean = true; // allow "more" link when too many events
        editable: boolean = true;
        eventDurationEditable: boolean = true;
        eventStartEditable: boolean = true;
        eventTimeFormat: Object = {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: false, // false, 'short', 'narrow'
            hour12: false // true, false
        };
        selectMirror: boolean = true; // Whether to draw a "placeholder" event while the user is dragging.
        selectable: boolean = false;
        slotLabelFormat: Object = {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: false, // false, 'short', 'narrow'
            hour12: false // true, false
        };

        dateClick: Function = function(dateClickedOn: any, event: any) {
            // Called when the day link is clicked
        };

        eventAdd: Function = function(addInfo: any) {
            // Called after this event is rendered on the calendar
        };

        eventAllow: Function = function(dropLocation: any, draggedEvent: EventObject) {
            // Exact programmatic control over where an event can be dropped.
            if (!draggedEvent.durationEditable || (draggedEvent.editable && !draggedEvent.editable) || !draggedEvent.startEditable) {
                if (!appn.views.tasks.calendar._isCanEditOrMoveMessageShowing)
                    toast.notify(toast.Type.error, draggedEvent.extendedProps.canEditOrMoveMessage);

                appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = true;
                return false;
            }

            if (_calendarEdits.maxSaveChanges < _calendarEdits.distinctTasks(draggedEvent.extendedProps.taskId)) {
                if (!appn.views.tasks.calendar._isCanEditOrMoveMessageShowing)
                    toast.notify(toast.Type.error, T('<b>Maximum Calendar Changes Reached</b>') + '<br>' +
                        T(`You can't change more than {0} Tasks in an editing session.`, _calendarEdits.maxSaveChanges) + '<br>' +
                        T('Hit Save or Cancel to apply/discard your current changes.'));

                appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = true;
                return false;
            }

            return true; // allow
        };

        eventClick: Function = function(eventInfo: any, jsEvent: any, view: any) {
            if (!eventInfo.event)
                return;

            const event = eventInfo.event as EventObject;

            if (event.extendedProps.isRecurring) {
                const buttonConfig: { [k: string]: any; } = {};
                buttonConfig.schedule = {
                    label: T('Schedule'),
                    className: 'btn-info',
                    callback: function() {
                        appn.location.navTo(`${_initArgs.taskRecurringEdit}/${event.id}`, [
                            {
                                name: 'bk',
                                value: 'Calendar_Tasks'
                            }
                        ]);
                        return true;
                    }
                };

                buttonConfig.details = {
                    label: '<span>' + T('Details') + '</span>',
                    className: 'btn-success',
                    callback: function() {
                        appn.location.navTo(_initArgs.tasksEdit, [
                            { name: 'taskRecurringId', value: event.id },
                            { name: 'bk', value: 'Calendar_Tasks' }
                        ]);
                        return true;
                    }
                };

                const modalContent = `<div><div class="form-group">` +
                    `<label class="col-form-label col-sm-4">${T('Recurring Task')}</label>` +
                    `<div class="col-sm-8">` +
                    `<label class="col-form-label">${event.extendedProps.recurringTaskName}</label>` +
                    `</div></div>` +
                    `<div class="form-group ${event.extendedProps.templateName ? '' : 'hide'}">` +
                    `<label class="col-form-label col-sm-4">${T('Template')}</label>` +
                    `<div class="col-sm-8">` +
                    `<label class="col-form-label">${event.extendedProps.templateName}</label>` +
                    `</div></div>` +
                    `<div class="form-group">` +
                    `<label class="col-form-label col-sm-4">${T('Start By')}</label>` +
                    `<label class="col-form-label col-sm-8">${event.extendedProps.startBy}</label>` +
                    `<label class="col-form-label col-sm-4">${T('Complete By')}</label>` +
                    `<label class="col-form-label col-sm-8">${event.extendedProps.completeBy}</label>` +
                    `</div>` +
                    `<div class="form-group ${event.allDay ? '' : 'hide'}">` +
                    `<label class="col-form-label col-sm-4">${T('All Day')}</label>` +
                    `<div class="col-sm-8">` +
                    `<label class="col-form-label"><i class="fa fa-check"></i></label>` +
                    `</div></div>` +
                    `<div class="form-group ${event.extendedProps.additionalInfo ? '' : 'hide'}">` +
                    `<label class="col-form-label col-sm-4">${T('Additional Info')}</label>` +
                    `<div class="col-sm-5">` +
                    `<label class="col-form-label">${event.extendedProps.additionalInfo}</label>` +
                    `</div></div></div>`;

                appn.dialog.custom({
                    message: modalContent,
                    title: `${event.title}`,
                    modalColor: 'modal-info',
                    closeButton: true,
                    buttons: !_calendarEdits.isInEditMode ? buttonConfig : null
                });

            } else {
                const queryString = appn.location.buildQueryString([
                    { name: 'id', value: event.id },
                    { name: 'taskRecurringId', value: '' },
                    { name: 'isLoadingIframe', value: 'true' },
                    { name: 'returnAction', value: 'Calendar' }
                ]);

                appn.iframe.openModal({
                    url: `${_initArgs.tasksEdit}/${queryString}`,
                    size: 'modal-xl'
                }).then(function(modal: JQuery<HTMLElement>) {
                    modal.on('hidden.bs.modal', function() {
                        appn.location.reloadCurrentPage();
                    });

                    addItemEvents(event, modal);
                });
            }
        };

        eventDidMount: Function = function(addInfo: any) {
            // Called before this event is rendered on the calendar
            const $cachedElement = $(addInfo.el);

            // Add ellipses if event text gets too long
            $cachedElement.find('.fc-event-title').addClass('text-truncate');
            $cachedElement.find('.fc-event-time').css('min-width', '2.5rem');

            if (addInfo.event) {
                const event = addInfo.event;
                if (event.extendedProps.isRecurring) {
                    $cachedElement.css('opacity', '0.3');
                    $cachedElement.find('.fc-title').prepend('<i class="fa fa-repeat"></i>&nbsp;');
                }

                if (event.extendedProps.colorClass)
                    $cachedElement.addClass(event.extendedProps.colorClass);

                if (event.extendedProps.userColorCode)
                    $cachedElement.attr('style', `background-color:${event.extendedProps.userColorCode}; border-color:${event.extendedProps.userColorCode}`);

                if (event.extendedProps.flashMe && _calendarEdits.hasUnsavedChanges())
                    $cachedElement.addClass('flash-success');
            }
        };

        eventOverlap: Function = function(stillEvent: any, movingEvent: any) {
            // Determines if events on the calendar, when dragged and resized, are allowed to overlap each other.
            
            return true; // allow overlap
        };

        eventResize: Function = function(eventResizeInfo: any) {
            // Triggered when resizing stops and the event has changed in duration.
            const event = eventResizeInfo.event as EventObject;
            if ((window as any).moment(event.start).isBefore((window as any).moment().startOf('day'))) {
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Change Task Occurring in the Past?'),
                    message: T('This Task is configured to occur in the past.<br>Are you sure you want to continue changing it?<br><br>Hit <b>OK</b> to proceed.'),
                    isDeleteAction: true,
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (result)
                            // Add move to edited events
                            _calendarEdits.addItem(newEditItem('EditResized', event));
                        else
                            // Revert change
                            eventResizeInfo.revert();
                    }
                });

                return;
            }

            _calendarEdits.addItem(newEditItem('EditResized', event));
        };

        eventResizeStart: Function = function(event: any, jsEvent: any, ui: any, view: any) {
            // Triggered when event resizing begins.
        };

        eventResizeStop: Function = function(event: any, jsEvent: any, ui: any, view: any) {
            // Triggered when event resizing stops.
        };

        events: Array<any> = [];

        eventsSet: Function = function(events: any) {
            // Called after all events are rendered on the calendar
        };

        select: Function = function(start: any, end: any) {
            // A method for programmatically selecting a period of time.
            const isInEditMode = showInEditModeNotify();
            if (isInEditMode)
                return false;

            const allDay = !start.hasTime() && !end.hasTime();

            if (start.isBefore((window as any).moment().startOf('day')))
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Create Task in the Past?'),
                    message: T('Are you sure you want to create a Task in the past?') + '<br><br>' +
                        T('<b>Start By: </b>{0}<br><b>Complete By: </b>{1}', start.toISOString(), end.toISOString()) + '<br><br>' +
                        T('Hit<b>OK</b> to create this Task now.'),
                    isDeleteAction: true,
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (result)
                            appn.tasks.showAddNewDialog(false, true, start.toISOString(), end.toISOString(), allDay);
                    }
                });
            else
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Create New Task'),
                    message: T('<b>Start By: </b>{0}<br><b>Complete By: </b>{1}', start.toISOString(), end.toISOString()) + '<br><br>' +
                             T('Hit<b>OK</b> to create this Task now.'),
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (result)
                            appn.tasks.showAddNewDialog(false, true, start.toISOString(), end.toISOString(), allDay);
                    }
                });
        };

        // ===== Calendar Events variables and callbacks end =====

        // ===== Dragging variables and callbacks start =====
        dragRevertDuration: number = 250;
        dragScroll: boolean = true; // Whether to automatically move scroll containers during event drag-and-drop or while selecting.
        droppable: boolean = false; // Determines if jQuery UI draggables can be dropped onto the calendar.

        drop: Function = function(dropInfo: any) {
            // Called when a valid jQuery UI draggable has been dropped onto the calendar.
            // is the "remove after drop" checkbox checked?
            if ($('#drop-remove').is(':checked'))
                // if so, remove the element from the "Draggable Events" list
                $(dropInfo.draggedEl).remove();
        };

        eventDragStart: Function = function(event: any, jsEvent: any, ui: any, view: any) {
            // Triggered when event dragging begins.
        };

        eventDragStop: Function = function(event: any, jsEvent: any, ui: any, view: any) {
            // Triggered when event dragging stops.
            appn.views.tasks.calendar._isCanEditOrMoveMessageShowing = false;

        };

        eventDrop: Function = function(info: any) {
            // Triggered when dragging stops and the event has moved to a different day/time.
            if (!info.event)
                return;

            const event = info.event as EventObject;

            if ((window as any).moment(event.start).isBefore((window as any).moment().startOf('day')))
                appn.dialog.confirm({
                    modalColor: 'modal-info',
                    title: T('Change Task Occurring in the Past?'),
                    message: T('This Task is configured to occur in the past.<br>Are you sure you want to continue changing it?<br><br>Hit <b>OK</b> to proceed.'),
                    isDeleteAction: true,
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function(result: any) {
                        if (result)
                            // Add move to edited events
                            _calendarEdits.addItem(newEditItem('EditMoved', event));
                        else
                            // Revert change
                            info.revert();
                    }
                });

            else
                // Add move to edited events
                info.event.setExtendedProp('hasBeenMoved', true);
                _calendarEdits.addItem(newEditItem('EditMoved', event));

            Object.assign(event.extendedProps.flashMe, _calendarEdits.hasUnsavedChanges());
        };

        // ===== Dragging variables and callbacks end =====

        // ===== Customization variables and callbacks start =====
        bootstrapFontAwesome: Object = {
            close: 'fa-times',
            prev: 'fa-chevron-left',
            next: 'fa-chevron-right',
            prevYear: 'fa-angle-double-left',
            nextYear: 'fa-angle-double-right'
        };

        // ===== Customization variables and callbacks end =====

        constructor(parentId: string) {
            this.aspectRatio = getParentAspectRatio(parentId);
        }

    }

    interface EventObject {
        id: string;
        groupId: string;
        allDay: boolean;
        start: Date;
        end: Date;
        startStr: string; // ISO8601 string
        endStr: string; // ISO8601 string
        title: string;
        url: string | null; // can be used to navigate to a URL on event click
        classNames: Array<string>;
        editable: boolean;
        startEditable: boolean;
        durationEditable: boolean;
        resourceEditable: boolean;
        display: string; // The rendering type of this event.Can be 'auto', 'block', 'list-item', 'background', 'inverse-background', or 'none'
        overlap: boolean | Function;
        constraint: object;
        backgroundColor: string;
        borderColor: string;
        textColor: string;
        extendedProps: ExtendedProps;
        source: object | null;
    }

    interface ExtendedProps {
        parentId: string;
        taskStatus: any;
        taskType: string;
        isRecurring: boolean;
        startBy: any;
        completeBy: any;
        templateName: string;
        additionalInfo: string;
        recurringTaskName: string;
        taskRecurringId: string;
        taskId: string;
        taskName: string;
        completeAtText: string;
        completeAtLat: any;
        completeAtLon: any;
        canEditOrMoveMessage: string;
        assignedToId: string;
        userColorCode: string;
        colorClass: string;
        flashMe: boolean;
        hasBeenMoved: boolean;
    }

    enum ViewSpecs {
        dayGrid = 'dayGrid',
        dayGridDay = 'dayGridDay',
        dayGridMonth = 'dayGridMonth',
        dayGridWeek = 'dayGridWeek',
        list = 'list',
        listDay = 'listDay',
        listMonth = 'listMonth',
        listWeek = 'listWeek',
        listYear = 'listYear',
        timeGrid = 'timeGrid',
        timeGridDay = 'timeGridDay',
        timeGridWeek = 'timeGridWeek'
    }

    function getParentAspectRatio(parentId: string): number {
        const height = Number($(`#${parentId}`).closest('.card-body').css('min-height').replace('px', '')) ?? 800;
        const width = $(`#${parentId}`).closest('.card-body').outerWidth() ?? 1000;
        const heightOffset = 5 + ($('.fc-header-toolbar').outerHeight() ?? 83);
        const widthOffset = Number($(`#${parentId}`).closest('.card-body').css('padding-left').replace('px', '')) + Number($(`#${parentId}`).closest('.card-body').css('padding-right').replace('px', ''));
        const marginNeededBelowCard = 10;

        return (width - widthOffset) / (height - (heightOffset + marginNeededBelowCard));
    }
}
